import { useState, useEffect, useCallback } from 'react'
import { useAnaliseLocalService } from 'hooks/useAnaliseLocalService'
import { useCadaverService } from 'hooks/useCadaverService'
import { useVestigioFixadoService } from 'hooks/useVestigioFixadoService'

export const useFormDadosBasicos = ({ idLocal, idExameRealizado, fetchLocais, cadaveresState, onConfirmSuccess }) => {
  const analiseLocalService = useAnaliseLocalService()
  const [processandoLocal, setProcessandoLocal] = useState(true)
  const [analiseLocal, setAnaliseLocal] = useState({})
  const [processandoConfirmacao, setProcessandoConfirmacao] = useState(false)

  const [values, setValues] = useState({
    descricao: '',
    classificacao: '',
    tipoLocal: '',
    tipoLocalInputText: '',
    populares: '',
    isolamento: '',
    idoneidade: '',
  })

  const [errors, setErrors] = useState({})

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('descricao' in fieldValues) {
      temp.descricao = fieldValues.descricao?.trim() ? '' : 'Descrição é obrigatória'
    }
    if ('classificacao' in fieldValues) {
      temp.classificacao = fieldValues.classificacao ? '' : 'Classificação é obrigatória'
    }
    setErrors(temp)
    return Object.values(temp).every((x) => x === '')
  }

  useEffect(() => {
    analiseLocalService.getAnaliseLocalDeExame(idExameRealizado, idLocal, setAnaliseLocal, setProcessandoLocal)
  }, [idLocal, idExameRealizado])

  useEffect(() => {
    if (analiseLocal && analiseLocal.id) {
      setValues({
        descricao: analiseLocal.descricao || '',
        classificacao: analiseLocal.classificacao || '',
        tipoLocal: analiseLocal.tipoLocal || '',
        tipoLocalInputText: analiseLocal.tipoLocalInputText || '',
        populares: analiseLocal.populares || '',
        isolamento: analiseLocal.isolamento || '',
        idoneidade: analiseLocal.idoneidade || '',
        id: analiseLocal.id,
      })
    }
  }, [analiseLocal])

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues((prev) => ({ ...prev, [name]: value }))
    validate({ [name]: value })
  }

  const handleAutocompleteChange = (name, newValue) => {
    setValues((prev) => ({ ...prev, [name]: newValue }))
    validate({ [name]: newValue })
  }

  const confirmInformacoesGerais = async () => {
    if (!validate()) return
    await analiseLocalService.setarAnaliseLocalDeExameRealizado(
      idLocal,
      idExameRealizado,
      values,
      setProcessandoConfirmacao
    )
    await fetchLocais()
    if (onConfirmSuccess) {
      onConfirmSuccess()
    }
  }

  const cadaveresAnalisados = useCallback(() => {
    if (!cadaveresState || !cadaveresState.length) return true
    return cadaveresState.every(
      (cadaver) => cadaver.anaCadLocs && cadaver.anaCadLocs.length > 0
    )
  }, [cadaveresState])

  const hasError = (field) => {
    return !!errors[field]
  }

  return {
    processandoLocal,
    values,
    errors,
    handleChange,
    handleAutocompleteChange,
    confirmInformacoesGerais,
    processandoConfirmacao,
    cadaveresAnalisados,
    hasError,
  }
}

export const useFormCadaveres = ({ idLocal, idExameRealizado, setCadaveresState }) => {
  const cadaverService = useCadaverService()
  const [cadaveres, setCadaveres] = useState([])
  const [processandoCadaveres, setProcessandoCadaveres] = useState(false)

  const fetchCadaveres = useCallback(() => {
    cadaverService.getCadaveresDeLocalParaExame(
      idLocal,
      idExameRealizado,
      setCadaveres,
      setProcessandoCadaveres
    )
  }, [idLocal, idExameRealizado])

  useEffect(() => {
    fetchCadaveres()
  }, [fetchCadaveres])


  useEffect(() => {
    setCadaveresState(cadaveres)
  }, [cadaveres, setCadaveresState])

  return {
    cadaveres,
    processandoCadaveres,
    fetchCadaveres,
  }
}

export const useFormVestigiosFixados = ({ idLocal, idExameRealizado }) => {
  const vestigioFixadoService = useVestigioFixadoService()
  const [vestigiosFixados, setVestigiosFixados] = useState([])
  const [processandoVestigiosFixados, setProcessandoVestigiosFixados] = useState(false)
  const [openFormVestigioFixado, setOpenFormVestigioFixado] = useState(false)
  const [openAlertDeletarVestigioFixado, setOpenAlertDeletarVestigioFixado] = useState(false)
  const [idVestigioFixadoSelecionado, setIdVestigioFixadoSelecionado] = useState(null)

  const fetchVestigiosFixados = useCallback(() => {
    vestigioFixadoService.getVestigiosFixadosDeLocalDoExame(
      idLocal,
      idExameRealizado,
      setVestigiosFixados,
      setProcessandoVestigiosFixados
    )
  }, [idLocal, idExameRealizado])

  useEffect(() => {
    fetchVestigiosFixados()
  }, [fetchVestigiosFixados])

  const handleClickDeletarVestigioFixado = (rowData) => {
    setIdVestigioFixadoSelecionado(rowData.id)
    setOpenAlertDeletarVestigioFixado(true)
  }

  const handleCloseDeletarVestigioFixado = () => {
    setIdVestigioFixadoSelecionado(null)
    setOpenAlertDeletarVestigioFixado(false)
  }

  const handleBotaoAdicionarVestigioFixado = () => {
    setOpenFormVestigioFixado(true)
  }

  const confirmDeletarVestigioFixado = async () => {
    if (!idVestigioFixadoSelecionado) return
    await vestigioFixadoService.deletarVestigioFixado(
      idVestigioFixadoSelecionado,
      setProcessandoVestigiosFixados
    )
    fetchVestigiosFixados()
    setOpenAlertDeletarVestigioFixado(false)
  }

  return {
    vestigiosFixados,
    processandoVestigiosFixados,
    setVestigiosFixados,
    setProcessandoVestigiosFixados,
    openFormVestigioFixado,
    setOpenFormVestigioFixado,
    openAlertDeletarVestigioFixado,
    handleClickDeletarVestigioFixado,
    handleCloseDeletarVestigioFixado,
    handleBotaoAdicionarVestigioFixado,
    confirmDeletarVestigioFixado,
  }
}
